import { observer } from "mobx-react-lite";

import { SettingsTable } from "@/components/SettingsTable";

import { useCustomProvidersTable } from "./hooks/useCustomProvidersTable";
import { CustomProvider } from "@/queries/providers/types";
import { useState } from "react";
import { CustomProvidersDialog } from "./CustomProvidersDialog";

export const CustomProviders = observer(() => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    columns,
    actions,
    isLoadingProviders,
    providers,
    customProviders,
    isEditModalOpen,
    customProvider,
    setCustomProvider,
    setIsEditModalOpen,
    setIsPreviewModalOpen,
    isPreviewModalOpen,
    contextMenuItems,
  } = useCustomProvidersTable();

  return (
    <div className="flex flex-col">
      <SettingsTable<CustomProvider>
        data={customProviders}
        onRowClick={(provider) => {
          setCustomProvider(provider);
          setIsEditModalOpen(true);
        }}
        contextMenuItems={contextMenuItems}
        columns={columns}
        actions={actions}
        isLoading={isLoadingProviders}
        emptyStateMessage="No custom providers found"
      />
      <CustomProvidersDialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isEditModalOpen={isEditModalOpen}
        isPreviewModalOpen={isPreviewModalOpen}
        customProvider={customProvider}
        setIsEditModalOpen={setIsEditModalOpen}
        setIsPreviewModalOpen={setIsPreviewModalOpen}
        setCustomProvider={setCustomProvider}
        isLoadingProviders={isLoadingProviders}
        providers={providers}
      />
    </div>
  );
});
